"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const components_common_inputs_1 = require("@hotelplan/components.common.inputs");
const DEFAULT_TYPE_VALUE = 'text';
const TextInput = props => {
    const { id, name, value, valueGuard, label, hideLabel, placeholder, onChange, testId, type = DEFAULT_TYPE_VALUE, customLabel } = props, restRawInput = __rest(props, ["id", "name", "value", "valueGuard", "label", "hideLabel", "placeholder", "onChange", "testId", "type", "customLabel"]);
    const onInputChange = (e) => {
        e.preventDefault();
        const nextValue = e.target.value;
        if (valueGuard && !valueGuard(nextValue))
            return;
        onChange(e.target.value, e);
    };
    return (react_1.default.createElement(components_common_inputs_1.BaseInput, Object.assign({ id: id || name, "data-id": testId, name: name, value: value, onChange: onInputChange, label: label, hideLabel: hideLabel, placeholder: placeholder, fullWidth: true, type: type, customLabel: customLabel }, restRawInput)));
};
exports.default = TextInput;
//# sourceMappingURL=TextInput.js.map